import type { Lang } from "@noli/core";
import { injectScope } from "./util";
export enum Login_Words {
  register = "register",
  modalTitle = "login-modal-title",
  changPassword = "change-password",
  login = "login",
  loginExistAccount = "login-exist-account",
  logout = "logout",
  phoneNum = "phone-number",
  phonePhd = "phone-login-placeholder",
  phoneRegisterPhd = "phone-register-placeholder",
  password = "password",
  newPassword = "new-password",
  forgotPassword = "forgotten-password",
  passwordPhd = "password-placeholder",
  registerPasswordPhd = "register-password-placeholder",
  username = "username",
  usernamePhd = "username-placeholder",
  code = "verify-code",
  getCode = "get-verify-code",
  codeDisable = "get-verify-code-disabled",
  phoneCodePhd = "phone-verify-code-placeholder",
  emailCodePhd = "email-verify-code-placeholder",
  emailExist = "login-exist-email",
  phoneExist = "login-exist-phone",
  emailAddr = "email-address",
  emailPhd = "email-placeholder",
  back = "back",
  moreAuth = "more-auth",
  registerNewAccount = "register-new-account",
  servicePolicy = "service-policy",
  privacyPolicy = "privacy-policy",
  wechatAuth = "wechat-auth",
  googleAuth = "google-auth",
  codeOrAccountAuth = "code-or-account-auth",
  codeAuth = "code-auth",
  accountAuth = "account-auth",
  bindPhone = "phone-bind",
  agreePolicy = "agree-policy",
  and = "agree-policy-and",
  bindPhoneFooter = "phone-bind-footer",
  forgotFooter = "forget-footer",
}
injectScope("login", Login_Words);

export const loginLangRecords: Record<Lang, Record<Login_Words, string>> = {
  zh: {
    [Login_Words.register]: "注册",
    [Login_Words.modalTitle]: "登录或注册 Nolibox Creator",
    [Login_Words.changPassword]: "更改密码",
    [Login_Words.login]: "登录",
    [Login_Words.loginExistAccount]: "登录已有账号",
    [Login_Words.logout]: "登出",
    [Login_Words.phoneNum]: "手机号",
    [Login_Words.phonePhd]: "请输入手机号",
    [Login_Words.phoneRegisterPhd]: "请输入用于注册的手机号",
    [Login_Words.password]: "密码",
    [Login_Words.newPassword]: "新密码",
    [Login_Words.forgotPassword]: "忘记密码？",
    [Login_Words.passwordPhd]: "请输入密码",
    [Login_Words.registerPasswordPhd]: "请输入6-30位密码",
    [Login_Words.username]: "用户名",
    [Login_Words.usernamePhd]: "请输入用户名",
    [Login_Words.code]: "验证码",
    [Login_Words.getCode]: "获取验证码",
    [Login_Words.codeDisable]: "$s后可再次获取",
    [Login_Words.phoneCodePhd]: "请输入短信验证码",
    [Login_Words.emailCodePhd]: "请输入邮箱验证码",
    [Login_Words.emailExist]: "该邮箱已注册",
    [Login_Words.phoneExist]: "该手机号已注册",
    [Login_Words.emailAddr]: "邮箱地址",
    [Login_Words.emailPhd]: "请输入邮箱账号",
    [Login_Words.back]: "返回",
    [Login_Words.moreAuth]: "更多登录方式",
    [Login_Words.registerNewAccount]: "注册新账号",
    [Login_Words.servicePolicy]: "用户服务协议",
    [Login_Words.privacyPolicy]: "隐私协议",
    [Login_Words.wechatAuth]: "微信扫码",
    [Login_Words.googleAuth]: "谷歌登录",
    [Login_Words.codeOrAccountAuth]: "短信验证/账号密码登录",
    [Login_Words.codeAuth]: "短信验证码",
    [Login_Words.accountAuth]: "账号密码",
    [Login_Words.bindPhone]: "绑定手机",
    [Login_Words.agreePolicy]: "未注册用户登录后自动注册，登录即代表同意",
    [Login_Words.and]: "和",
    [Login_Words.bindPhoneFooter]: "按照相关要求，账号需绑定手机号",
    [Login_Words.forgotFooter]: "如账号手机无法接收验证码，请与图宇宙后台联系",
  },
  en: {
    [Login_Words.register]: "Sign up",
    [Login_Words.modalTitle]: "Sign in or sign up to Nolibox",
    [Login_Words.changPassword]: "Reset password",
    [Login_Words.login]: "Sign in",
    [Login_Words.loginExistAccount]: "Sign in",
    [Login_Words.logout]: "Sign out",
    [Login_Words.phoneNum]: "Phone Number",
    [Login_Words.phonePhd]: "Enter phone number",
    [Login_Words.phoneRegisterPhd]: "Enter phone number for Sign up",
    [Login_Words.password]: "Password",
    [Login_Words.newPassword]: "New Password",
    [Login_Words.forgotPassword]: "Forgot password?",
    [Login_Words.passwordPhd]: "Enter password",
    [Login_Words.registerPasswordPhd]: "Set 6-30 chars password",
    [Login_Words.username]: "Name",
    [Login_Words.usernamePhd]: "Set user name",
    [Login_Words.code]: "Code",
    [Login_Words.getCode]: "Send Code",
    [Login_Words.codeDisable]: "Retry after $s",
    [Login_Words.phoneCodePhd]: "Enter verification code",
    [Login_Words.emailCodePhd]: "Enter verification code",
    [Login_Words.emailExist]: "This email has already been registered",
    [Login_Words.phoneExist]: "This phone has already been registered",
    [Login_Words.emailAddr]: "Email address",
    [Login_Words.emailPhd]: "Enter email address",
    [Login_Words.back]: "Back",
    [Login_Words.moreAuth]: "Another way",
    [Login_Words.registerNewAccount]: "Sign up",
    [Login_Words.servicePolicy]: "Terms of Use",
    [Login_Words.privacyPolicy]: "Privacy Policy",
    [Login_Words.wechatAuth]: "WeChat Login",
    [Login_Words.googleAuth]: "Continue with Google",
    [Login_Words.codeOrAccountAuth]: "Code/Password Login",
    [Login_Words.codeAuth]: "Code sign in",
    [Login_Words.accountAuth]: "Password sign in",
    [Login_Words.bindPhone]: "Phone Bind",
    [Login_Words.agreePolicy]: "By continuing, you agree to Nolibox’s",
    [Login_Words.and]: "and",
    [Login_Words.bindPhoneFooter]:
      "According to requirements, the account should bind mobile phone number",
    [Login_Words.forgotFooter]: "Send email to service@nolibox.com for help",
  },
};
